import "./sharedRitual.css";

/* Decorative concentric ripples — light strokes for dark sections. */
export default function RippleAccent({ className = "", tone = "light", rings = 5, testid = "ripple-accent" }) {
  const stroke = tone === "light" ? "#F7F4ED" : "#2A492C";
  const gold = "#B9A57A";
  return (
    <div className={`ripple-accent pointer-events-none select-none ${className}`} aria-hidden="true" data-testid={testid}>
      <svg viewBox="0 0 800 800" className="w-full h-full" focusable="false">
        <g fill="none">
          {Array.from({ length: rings }).map((_, i) => (
            <circle
              key={i}
              className="ripple-slow"
              cx="400"
              cy="400"
              r={90 + i * 62}
              stroke={i % 2 ? gold : stroke}
              strokeOpacity={0.5 - i * 0.07}
              strokeWidth={i === 0 ? 1.1 : 0.7}
              style={{ animationDelay: `${-i * 2.6}s` }}
            />
          ))}
          <circle cx="400" cy="400" r="6" fill={stroke} fillOpacity="0.5" />
        </g>
      </svg>
    </div>
  );
}
